import { lazy } from 'react';
import { NOT_FOUND } from 'redux-first-router';
import { constants, actions } from './actions';
import { constants as routingActions } from '../../../routing/store/Pages/actions';
import { isLoggedIn } from '../../../routing/marshal';
import createRoutesMap, {
  SIGN_IN_FORM,
  SIGN_IN_TOKEN_FORM,
  NEW_PASSWORD_FORM,
  UNLOCK_FORM,
  CHANGE_PASSWORD_FORM,
  CONFIRM_INVITE_FORM,
  INVITE_FORM,
  REGISTER_FORM,
} from '../../../devise/store/routes/routesMap';
import { actions as deviseRoutingActions } from '../../../devise/store/routes/actions';

const componentPathMap = {
  [SIGN_IN_FORM]: lazy(() => import('../../pages/SignIn')),
  [SIGN_IN_TOKEN_FORM]: lazy(() => import('../../pages/SignInTokenPage')),
  [NEW_PASSWORD_FORM]: lazy(() => import('../../pages/NewPassword')),
  [UNLOCK_FORM]: lazy(() => import('../../pages/Unlock')),
  [CHANGE_PASSWORD_FORM]: lazy(() => import('../../pages/ChangePassword')),
  [CONFIRM_INVITE_FORM]: lazy(() => import('../../pages/ChangePassword')),
  [INVITE_FORM]: lazy(() => import('../../pages/SignIn')), // Invite doesn't exist
  [REGISTER_FORM]: lazy(() => import('../../pages/Register')),
};

const deviseRoutesMap = createRoutesMap(componentPathMap);

const notFoundThunk = async (dispatch, getState) => {
  const loggedIn = isLoggedIn(getState());
  if (!loggedIn) dispatch(deviseRoutingActions.goToLogin());
};

const notFoundEntry = {
  pageTitle: '404',
  component: lazy(() => import('../../pages/Error404')),
  allowNoSubdomain: true,
  thunk: notFoundThunk,
};

const authenticatedAction = toAdd => ({
  conditions: [isLoggedIn, ...toAdd],
});

const coreRouteMap = {
  ...deviseRoutesMap,
  [routingActions.goToError401]: {
    path: '/errors/error-401',
    component: lazy(() => import('../../pages/Error404')),
    allowNoSubdomain: true,
  },
  [routingActions.goToError404]: {
    ...notFoundEntry,
    path: '/errors/error-404',
  },
  [routingActions.goToError500]: {
    path: '/errors/error-500',
    component: lazy(() => import('../../pages/Error500')),
    allowNoSubdomain: true,
  },
  [NOT_FOUND]: { ...notFoundEntry },
  [routingActions.noSubdomain]: {
    ...notFoundEntry,
    path: '/marketing/no_subdomain',
  },
  [constants.goToUserProfile]: {
    component: lazy(() => import('../../pages/UserProfile')),
    ...authenticatedAction([]),
    path: '/account/users/settings/:page',
  },
  [constants.goToSettings]: {
    path: '/account/users/settings',
    redirect: x => actions.goToUserProfile({ ...x, page: 'general' }),
    search: {title: "Account Settings", description: "User Profile", app: "analyticsHub"},
  },
};

export default coreRouteMap;
